import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import CloudStorage from "../../CloudStorage/CloudStorage";
import DownloadwithDisplayProper from "./FilesRelevent/DownloadwithDisplayProper";
import { addproposaltowishlist } from "../../redux/posts/action";
import { useDispatch } from "react-redux";
import CustomeMilestone from "./CustomeLabel/CustomeMilestone";
import { formatNumberWithCommas } from "./AllDateTimeReleventFormate";
import GetPrice from "../Modules/MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetPrice";
import GetLocation from "../CustomComponents/GetLocation";
import ProfilePic from "../../assests/imgs/Profileplaceholder.svg";
import { getJobProjectProposalsStatusLabel, decodeHtml } from "../../assests/extention/commonfunction";
import RoleLabel from "./RoleLabel";
import CustomReactQuillDescription from "./CustomeLabel/ReactQuill/CustomReactQuillDescription";
import YearRange from "./YearRange";

export default function ViewProfilePopup({
  setModal,
  modal,
  posts,
  profiledetails,
  comformhireExpert,
}) {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [wish, setwish] = useState("");

  useEffect(() => {
    if (profiledetails) {
      setwish(profiledetails.wishlist ? false : true);
    }
  }, [profiledetails]);

  const letChat = () => {
    const data = {
      post_id: profiledetails?.id,
      user_id: profiledetails?.user_id,
    };
    navigate(`/${lan}/account/chats/`, { state: { userdetails: data } });
  };

  const saveToWishlist = (id) => {
    setwish(!wish);
    dispatch(addproposaltowishlist(id, posts?.id));
  };

  console.log(posts, 'posts');


  return (
    <div>
      <Modal isOpen={modal} keyboard={false} className="profile-modal">
        <button
          onClick={() => {
            setModal(false);
            setwish(0);
          }}
          className="btn close-button"
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
            alt=""
          />
        </button>
        <ModalBody>
          <div className="proposal-first">
            <div className="proposal-left">
              <img src={profiledetails?.profile_image ? profiledetails?.profile_image : ProfilePic} alt="" />
              <div>
                <h5>
                  {decodeHtml(profiledetails?.first_name)} {decodeHtml(profiledetails?.last_name)}
                  <span>
                    <i className="fa-solid fa-star"></i>
                    {profiledetails?.expert_rating || 0} ({profiledetails?.expert_comment_count || 0} reviews)
                  </span>
                </h5>
                <p>{decodeHtml(profiledetails?.designation)}</p>
              </div>
            </div>
            <div className="expert-right">
              <button
                className="btn message-btn"
                onClick={() => {
                  letChat();
                }}
              >
                Chat with <RoleLabel role_type={profiledetails?.role_type} />
              </button>
              <button
                disabled={
                  posts?.type == 1
                    ? profiledetails?.status != 1
                    : profiledetails?.status != 21
                }
                onClick={() => {
                  comformhireExpert(profiledetails?.id);
                }}
                className="btn message-btn active"
              >
                {getJobProjectProposalsStatusLabel(profiledetails?.status)}
              </button>

              <button
                className="btn menu-btn"
                onClick={() => {
                  saveToWishlist(profiledetails?.id);
                }}
              >
                {wish != 1 ? (
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/heart-active.svg`}
                    alt=""
                  />
                ) : (
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/heart.svg`}
                    alt=""
                  />
                )}
              </button>
            </div>
          </div>

          <div className="expertdetail-second ">
            <div className="row">
              <div className="col-md-8 expert-second-right">
                <h4>Proposal Details</h4>
                {
                  profiledetails?.about &&
                  <div className="expert-sub-sec m-0">
                    <h6>About <RoleLabel role_type={profiledetails?.role_type} /></h6>
                    <p className="cover-p"><CustomReactQuillDescription value={profiledetails?.about} displyreadorless={true} key={profiledetails?.id} /></p>
                    <br></br>
                  </div>
                }
                <div className="expert-sub-sec m-0">
                  <h6>Cover letter</h6>
                  <p className="cover-p"><CustomReactQuillDescription value={profiledetails?.message} displyreadorless={true} key={profiledetails?.id}  /></p>
                </div>
                {posts?.type == 1 && (
                  <div className="expert-sub-sec">
                    <h6>Propose price</h6>
                    <h4 className="pb-0">
                      SAR {formatNumberWithCommas(profiledetails?.price)}
                    </h4>
                  </div>
                )}
                {posts?.type == 3 && (
                  <div className="expert-sub-sec">
                    <h6>Proposed price</h6>
                    <GetPrice
                      type={posts?.type}
                      price={profiledetails?.price}
                      hiring_type={posts?.hiring_type}
                    />
                  </div>
                )}
                {posts?.type == 3 && (
                  <GetLocation
                    type={posts?.type}
                    city_name={posts?.city_name}
                    country_title={posts?.country_title}
                  />
                )}
                <div className="expert-sub-sec">
                  {profiledetails?.files?.length > 0 &&
                    Array.isArray(profiledetails.files) && (
                      <div className="lang-sec">
                        <h6>Attachments</h6>
                        <div className="images d-flex flex-wrap image-crop-img" style={{ gap: '30px' }} >
                          {profiledetails.files.map((item, index) => {
                            return <DownloadwithDisplayProper item={item} />;
                          })}
                        </div>
                      </div>
                    )}
                </div>

                {posts?.type == 1 && (
                  <div className="expert-sub-sec">
                    <h6>Project duration</h6>
                    <h4 className="pb-0">
                      <>
                        {profiledetails?.duration}&nbsp;
                        {profiledetails?.duration_type == 2
                          ? "Days"
                          : profiledetails?.duration_type == 3
                            ? "Weeks"
                            : profiledetails?.duration_type == 4
                              ? "Months"
                              : ""}
                      </>
                    </h4>
                  </div>
                )}
                <div className="expert-sub-sec">
                  <h6>Competencies</h6>
                  <div className="skills">
                    {Array.isArray(profiledetails?.skills) &&
                      profiledetails.skills.map((skill, index) => (
                        <p key={index}>{decodeHtml(skill?.title)}</p>
                      ))}
                  </div>
                </div>
                {profiledetails && profiledetails?.industries.length != 0 &&
                  <div className="expert-sub-sec">
                    <h6>Industries:</h6>
                    <div className="skills">
                      {Array.isArray(profiledetails?.industries) &&
                        profiledetails.industries.map((skill, index) => (
                          <p key={index}>{decodeHtml(skill?.title)}</p>
                        ))}
                    </div>
                  </div>}
                <div className="expert-sub-sec">
                  <CustomeMilestone milestones={profiledetails?.milestones} />
                </div>

              </div>
              <div className="col-md-4 expert-second-left">
                {/* <p>
                  {profiledetails.role_type == 4
                    ? "About Company"
                    : "About Expert"}
                </p> */}
                <div className="about-expert">
                  {Array.isArray(profiledetails?.language) && <h6>language</h6>}
                  {Array.isArray(profiledetails?.language) &&
                    profiledetails?.language?.map((item, index) => (
                      <p >
                        {item?.language} - {item?.proficiency}
                      </p>
                    ))}
                </div>
                <div className="about-expert">
                  {profiledetails?.education.length != 0 && <h6>Academic info</h6>}
                  {Array.isArray(profiledetails?.education) &&
                    profiledetails?.education?.map((item, index) => (
                      <>
                        <p>
                          {decodeHtml(item?.field)} - {decodeHtml(item?.university)}
                        </p>
                        <p>
                          {item?.from_year} - {item?.to_year}
                        </p>
                      </>
                    ))}
                </div>
                <div className="about-expert">
                  {profiledetails?.experience.length != 0 && <h6>Employment</h6>}
                  {Array.isArray(profiledetails?.experience) &&
                    profiledetails?.experience?.map((item, index) => (
                      <>
                        <p>
                          {decodeHtml(item?.designation)} - {decodeHtml(item?.company)}
                        </p>
                        <YearRange fromYear={item?.from_year} toYear={item?.to_year} />
                      </>
                    ))}
                </div>
                {profiledetails?.total_experience ? (
                  <div className="about-expert">
                    <h6>Experience</h6>
                    <p>{profiledetails.total_experience} Years</p>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </ModalBody>
        {/* <div className='modal-footer'>
                    <button className='btn' onClick={() => { setModal(state => !state); navigate(`/${lan}/account/upgrademembership`) }}>See Full Profile</button>
                </div> */}
      </Modal>
    </div>
  );
}
